import { createGlobalStyle, css } from 'styled-components';
import reset from 'styled-reset';
import { ThemeType } from './theme';
import checkOn from '../assets/icon-check-on.svg';
import checkOff from '../assets/icon-check-off.svg';

const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  ${reset};

  * {
  box-sizing : border-box;
  font-family: 'NotoSansCJKkr' !important;
  }

  body {
    line-height: 1.5;
    letter-spacing: -1.14px;
    font-family: 'NotoSansCJKkr' !important;
  }
  
  input, button {
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: .3rem;
    outline: none;
    transition: ${(props) => props.theme.transition.default};
    &:hover {
      opacity: 0.8;
    }
  }

  button {
    cursor: pointer;
    padding: .5rem;
  }

  button:active {
    border: 1px solid ${(props) => props.theme.colors.main};
  }

  input {
    border: 1px solid ${(props) => props.theme.colors.border};
  }

  input[type=checkbox] {
    -ms-transform: scale(1.5); /* IE */
    -moz-transform: scale(1.5); /* FF */
    -webkit-transform: scale(1.5); /* Safari and Chrome */
    -o-transform: scale(1.5); /* Opera */
    cursor: pointer;
  }

  // 커스텀 체크박스
  input[type='checkbox'] {
    display: none;
  }
  input[type='checkbox'] + label {
    cursor: pointer;
  }
  input[type='checkbox'] + label span {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-right: 5px;
    vertical-align: middle;
    background: url(${checkOff}) center center no-repeat;
    cursor: pointer;
    margin-top: -3px;
  }
  input[type='checkbox']:checked + label span {
    background: url(${checkOn}) center center no-repeat;
  }

  input:focus {
    border: 1px solid${(props) => props.theme.colors.main};
  }

  ol, ul, li {
    list-style: none;
  }

  a {
    display: inline-block;
    text-decoration: none;
    color: ${(props) => props.theme.colors.black};
  }

  strong,
  h1, h2, h3, h4, h5, h6 {
    font-weight: 900;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export default GlobalStyle;

export const BorderR = css`
  border-radius: 5px;
`;

export const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
